import { Note } from './client.model';
import { ServerResponse } from './server-response.model';

export class VisitDetails {
  broker?: {
    name?: string;
    email?: string;
    id?: string;
    phone?: string;
    photo?: string;
  };
  documents:
    | [
        {
          name?: string;
          url?: string;
        }
      ]
    | null;
  guests:
    | [
        {
          name?: {
            firstName?: string;
          };
          email?: string;
          id?: string;
        }
      ]
    | null;
  id?: string;
  notes?: string;
  mainImage?: string;
  project?: {
    id: string;
    name: string;
  };
  property: {
    id: string;
    name: string;
  };
  projectType: {
    id: string;
    name: string;
  };
  status: string;
  typeProjectImage?: string;
  visitType?: string;
  visitDateTime?: string;
  originalVisitDateTime?: string;
  visitSummary: {
    clientComments: Note[];
    score: boolean;
    whatDidYouLike: string[];
  };
  visitUrl?: string;
  visitVideoUrl?: string;
}

export class VisitDetailsResponse extends ServerResponse {
  response: VisitDetails;
}

export class PropertyAvailable {
  id: string;
  name: string;
  image: string;
}

export class ClientLiked {
  id?: string;
  label: string;
}

export class ScoreVisit {
  score: boolean;
  whatDidYouLike: string[];
  newClientLiked: string;
  extraInformation: string;
  purchaseIntent: number;
}

export class VisitRoomData {
  day: number;
  month: number;
  year: number;
  IdProperty: string;
  dateTime?: string;
}

export enum ShipTypeEnum {
  timeslot_selected = 'timeslot_selected',
  timeslot_deselected = 'timeslot_deselected',
}

export interface NotificationData {
  datetime: string;
  idBroker: string;
  socketId: string;
}

export interface EmitNotificationData {
  roomName: string;
  datetime: string;
  shipType: string;
  socketId: string;
  brokerId?: string;
}

export interface BrokerSchedules {
  broker: string;
  slots: string[];
  parseSlot: string[];
}

export interface SchedulesSelected {
  date: string;
  selectedChips: string[];
}

export interface ChipData {
  value: string;
  isDisabled: boolean;
}

export interface DisableButton {
  date: string;
  values: string[];
}

export class RequestSchedules {
  propertyId: string;
  date: string;
}
